export function ProgressBar({ label, value, max = 10 }) {
	const progressPercentage = (value / max) * 100

	return (
		<div className='tw-w-full tw-space-y-1'>
			<div className='tw-flex tw-justify-between tw-items-center'>
				<span className='tw-text-sm tw-font-semibold'>{label}</span>
			</div>
			<div className='tw-w-full tw-bg-green-100 tw-rounded-full tw-h-5'>
				<div
					className='tw-bg-green-300 tw-h-5 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-py-1'
					style={{ width: `${progressPercentage}%` }}
				>
					<div className='tw-h-full tw-flex tw-items-center tw-gap-2'>
						<span className='tw-text-base tw-font-bold tw-text-gray-800'>{value.toFixed(1)}</span>
						<span className='tw-text-sm tw-font-bold tw-text-green-800'>/</span>
						<span className='tw-text-sm tw-font-bold tw-text-green-800'>{max}</span>
					</div>
				</div>
			</div>
		</div>
	)
}
